import createIcon from '../../createIcon';

/**
 * @component @name Grass
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMjBIMlYxOEg3Ljc1QzcuMDIgMTUuMTkgNC44MSAxMi45OSAyIDEyLjI2QzIuNjQgMTIuMSAzLjMxIDEyIDQgMTJDOC40MiAxMiAxMiAxNS41OCAxMiAyMFpNMjIgMTIuMjZDMjEuMzYgMTIuMSAyMC42OSAxMiAyMCAxMkMxNy4wNyAxMiAxNC41MiAxMy41OCAxMy4xMiAxNS45M0MxMy40MSAxNi41OSAxMy42NSAxNy4yOCAxMy43OSAxOEMxMy45MiAxOC42NSAxMy45OSAxOS4zMiAxMy45OSAyMEgyMS45OVYxOEgxNi4yNEMxNi45OCAxNS4xOSAxOS4xOSAxMi45OSAyMiAxMi4yNlpNMTUuNjQgMTEuMDJDMTYuNDIgOC45MyAxNy44NyA3LjE4IDE5LjczIDYuMDJDMTUuNDQgNi4xNiAxMiA5LjY3IDEyIDE0QzEyIDE0LjAxIDEyIDE0LjAyIDEyIDE0LjAyQzEyLjk1IDEyLjc1IDE0LjIgMTEuNzIgMTUuNjQgMTEuMDJaTTExLjQyIDguODVDMTAuNTggNi42NiA4Ljg4IDQuODkgNi43IDRDOC4xNCA1Ljg2IDkgOC4xOCA5IDEwLjcxQzkgMTAuOTIgOC45NyAxMS4xMiA4Ljk2IDExLjMyQzkuMzkgMTEuNTYgOS43OSAxMS44NCAxMC4xOCAxMi4xNEMxMC4zOSAxMC45NiAxMC44MyA5Ljg1IDExLjQyIDguODVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Grass = createIcon('Grass', [
  [
    'path',
    {
      d: 'M12 20H2V18H7.75C7.02 15.19 4.81 12.99 2 12.26C2.64 12.1 3.31 12 4 12C8.42 12 12 15.58 12 20ZM22 12.26C21.36 12.1 20.69 12 20 12C17.07 12 14.52 13.58 13.12 15.93C13.41 16.59 13.65 17.28 13.79 18C13.92 18.65 13.99 19.32 13.99 20H21.99V18H16.24C16.98 15.19 19.19 12.99 22 12.26ZM15.64 11.02C16.42 8.93 17.87 7.18 19.73 6.02C15.44 6.16 12 9.67 12 14C12 14.01 12 14.02 12 14.02C12.95 12.75 14.2 11.72 15.64 11.02ZM11.42 8.85C10.58 6.66 8.88 4.89 6.7 4C8.14 5.86 9 8.18 9 10.71C9 10.92 8.97 11.12 8.96 11.32C9.39 11.56 9.79 11.84 10.18 12.14C10.39 10.96 10.83 9.85 11.42 8.85Z',
      key: '1xafht',
    },
  ],
]);

export default Grass;
